type GetFilteredTags = {
  data: any;
  selectedTags: any;
  condition: boolean;
  lookUpKey?: string;
};

const getFilteredTags = ({
  data,
  selectedTags,
  condition,
  lookUpKey = 'uuid',
}: GetFilteredTags) => {
  if (condition) {
    const filteredTags = data?.filter((item: any) => {
      const keys = lookUpKey.split('.');
      const value = keys.reduce((obj, key) => obj?.[key], item);

      return selectedTags?.includes(value);
    });

    return filteredTags;
  }
  return data;
};

export { getFilteredTags };
